import axios from '../Backend';


export const changeAcdState = async (newAcdState) => {
    try {
        const bodyToSend = {
            newAcdState: newAcdState
        }
        await axios.put('/agentServices/changeAcdState', bodyToSend);
    } catch (e) {
        console.log(e)
    }
}

export const startBreak = async (breakReason) => {
    try {
        const bodyToSend = {
            breakReason: breakReason
        }
        await axios.post('/agentServices/startBreak', bodyToSend);
    } catch (e) {
        console.log(e)
    }
}

export const stopBreak = async () => {
    try {
        await axios.put('/agentServices/stopBreak', {});
    } catch (e) {
        console.log(e)
    }
}

export const changeAgentDialerState = async () => {
    try {
        await axios.put('/agentServices/changeAgentDialerState', {});
        // const resData=res.data
        // console.log(resData)
    } catch (e) {
        console.log(e)
    }
}

export const dialerReConnect = async () => {
    try {
        await axios.get('/agentServices/dialerReConnect');
    } catch (e) {
        console.log(e)
    }
}

export const getAgentWindowState = async () => {
    try {
        // debugger
        const res = await axios.get(`/agentServices/getAgentWindowState`);
        const resData = res.data
        return resData
    } catch (e) {
        if (e.response?.data) {
            console.log('getAgentWindowState :: Response Error', e.response.data)
        }
        else {
            console.log('getAgentWindowState :: Error', e)
        }
        throw e
    }
}

export const getBreakReasons = async () => {
    try {
        const res = await axios.get(`/agentServices/getBreakReasons`);
        const resData = res.data
        return resData
    } catch (e) {
        if (e.response?.data) {
            console.log('getBreakReasons :: Response Error', e.response.data)
        }
        else {
            console.log('getBreakReasons :: Error', e)
        }
        throw e
    }
}